export const POST_STATUS = {
    SCHEDULED: 'scheduled',
    PUBLISHING: 'publishing',
    PUBLISHED: 'published',
    FAILED: 'failed',
};
export const POST_STATUS_VALUES = Object.values(POST_STATUS);
export const MODERATION_STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
export const MODERATION_STATUS_VALUES = Object.values(MODERATION_STATUS);
//# sourceMappingURL=post-status.js.map